import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GridList, GridTile } from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import ZoomIn from 'material-ui/svg-icons/action/zoom-in';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

class ImageResults extends Component {

    state = {
        open: false,
        currentImg: '',
        window: window.innerWidth
    }

    componentDidMount(){
        window.addEventListener('resize', this.handleWindowResize)
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.handleWindowResize)
    }

    handleWindowResize = () => {
        this.setState({window: window.innerWidth})
    }

    handleOpen = (img) => {
        this.setState({ open: true, currentImg: img })
    }

    handleClose = () => {
        this.setState({ open: false })
    }

    render() {

        let imageList;
        const { images } = this.props;

        if (images) {
            imageList = (
                <GridList cellHeight={220} cols={this.state.window < 640? 1 : 3} >
                    {images.map(img => (
                        <GridTile title={img.tags} key={img.id} subtitle={
                            <span>by <strong>{img.user}</strong></span>}
                            actionIcon={<IconButton onClick={() => this.handleOpen(img.largeImageURL)}><ZoomIn color="white" /></IconButton>}>
                            <img src={img.largeImageURL} alt={img.tags} />
                        </GridTile>
                    ))}
                </GridList>
            )
        } else {
            imageList = null
        }

        const actions = [
            <FlatButton label="close" primary={true} onClick={this.handleClose} />
        ]

        return <div>{imageList}
            <Dialog actions={actions}
                modal={false}
                open={this.state.open}
                onRequestCLose={this.state.close}>
                <img src={this.state.currentImg} alt='' style={{ width: "100%" }} />
            </Dialog>
        </div>
    }
}

ImageResults.propTypes = {
    images: PropTypes.array.isRequired
}

export default ImageResults;
